import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=ecca0032&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecca0032')) {
      api.createRecord('ecca0032', component.options)
    } else {
      api.reload('ecca0032', component.options)
    }
    module.hot.accept("./AccordionItem.vue?vue&type=template&id=ecca0032&", function () {
      api.rerender('ecca0032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/AccordionItem.vue"
export default component.exports